import Icon from "@material-ui/icons/Person";
import AreasCreate from "./SubcontractorAreasCreate";
import AreasEdit from "./SubcontractorAreasEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "subcontractorAreas",
  edit: AreasEdit,
  create: AreasCreate,
  icon: Icon,
};
